/**
 * Vue runtime error codes (hp-service /log/error). Migration telemetry that is
 * not a failure lives in DebugCode (./debug) and is sent to /log/debug instead.
 */
export enum VueErrorCode {
  /** Uncaught Vue render / lifecycle error via app.config.errorHandler. */
  VUE_RUNTIME = 'error.vue.runtime',
}
